export const ka = {
  title: 'ნახშირბადის დაგროვების პოტენციალი ბუნებრივი ტყის ზრდისგან რესტიტუციად ადგილებში',
  subtitle: 'reforestable areas, 1 km, Cook-Patton et al. 2020',
  download_data: '',
  learn_more: '',
  content: [
    {
      label: 'ფუნქცია',
      value:
        'აფასებს იმ მაჩვენებელს, რომლის დროსაც ნახშირბადის თანმიმდევრობა შესაძლებელია მიწისზედა ცოცხალ ბიომასაში, ბუნებრივი ტყის ზრდის პირველი ოცდაათი წლის განმავლობაში პოტენციურად რესტიტატირებადი ადგილებში (Mg Carbon /ha / yr).',
    },
    {
      label: 'რეზოლუცია',
      value: '1 × 1 კმ',
    },
    {
      label: 'გეოგრაფიული გაშუქება',
      value:
        'გლობალური, Griscom et al. 2017 -ის აღდგენის ფარგლებში (რაც გამორიცხავს ბორეალურ, ბალახოვან ბიომებს და მოსავალს)',
    },
    {
      label: 'წყარო',
      value:
        'Cook-Patton, S.C., S.M. Leavitt, D. Gibbs, N.L. Harris, K. Lister, K.J. Anderson-Teixeira, R.D. Briggs, R.L. Chazdon, T.W. Crowther, P.W. Ellis, H.P. Griscom, V. Herrmann, K.D. Holl, R.A. Houghton, C. Larrosa, G. Lomax, R. Lucas, P. Madsen, Y. Malhi, A. Paquette, J.D. Parker, K. Paul, D. Routh, S. Roxburgh, S. Saatchi, J.van den Hoogen, W.S. Walker, C.E. Wheeler, S.A. Wood, L. Xu, B.W. Griscom. 2020. Mapping carbon accumulation potential from natural forest regrowth. Nature, in press. https://www.nature.com/articles/s41586-020-2686-x. This work resulted from a collaboration between The Nature Conservancy, World Resources Institute, and 18 other institutions.',
    },
    {
      label: 'სიხშირე',
      value: '',
    },
    {
      label: 'შინაარსის თარიღი',
      value: 'გამოიყენება ბუნებრივი ტყის ზრდის პირველი 30 წლის განმავლობაში.',
    },
    {
      label: 'გაფრთხილება',
      value:
        '- ღირებულებები წარმოადგენს საუკეთესო შეფასებებს, მაგრამ შეიცავს გაურკვევლობას. შედეგების სიზუსტე დამოკიდებულია მოდელის ტრენინგის მონაცემთა ხელმისაწვდომობაზე, რომელიც კონცენტრირებულია ათ ქვეყანაში. ამ მონაცემთა ფენასთან დაკავშირებული გაურკვევლობის რუკის ჩამოტვირთვა შესაძლებელია GFW- ის ღია მონაცემთა პორტალიდან.\n- ნახშირბადის დაგროვების მაჩვენებლები გამოიყენება მხოლოდ ბუნებრივი ტყის ზრდისთვის და არ ვრცელდება აღდგენის სხვა აქტიურ მეთოდებზე (აგრომეტყევეობა, პლანტაციები და ა.შ.).\n- ნახშირბადის დაგროვების მაჩვენებლები ხაზოვანია და საშუალოდ პირველი 30 წლის განმავლობაში იზრდება. 30 წელზე მეტი ხნის განმავლობაში გახანგრძლივება ზედმეტად შეაფასებს სეკვესტრაციას.\n- განაკვეთები ასახავს ნახშირბადის დაგროვებას მხოლოდ მიწისზედა ცოცხალ ბიომასაში. მიწისქვეშა ბიომასის, მკვდარი ორგანული ნივთიერებების და ნიადაგის ორგანული ნახშირბადის დაგროვება არ შედის, მაგრამ ქვემოთ მოყვანილი ნახშირბადის დაგროვების რუკა ხელმისაწვდომია მოთხოვნის საფუძველზე.\n- სავანებში, განაკვეთები ვრცელდება მხოლოდ ამ ბალახოვანი ტყის მატრიცების ტყიან ნაწილებზე.\n- ეს მონაცემები არ არის ტყის ზრდის პოტენციალის დეტალური საიტის დონის შეფასების შემცვლელი.',
    },
    {
      label: 'ლიცენზია',
      value: 'CC 4.0',
    },
  ],
  overview: {
    label: 'მიმოხილვა',
    value:
      'ეს რუკა გვიჩვენებს სიჩქარეს, რომლის დროსაც ტყეებს შეეძლოთ ატმოსფეროდან ნახშირბადის აღება და მისი შენახვა მიწისზედა ცოცხალ ბიომასაში ბუნებრივი ტყის ზრდის პირველი 30 წლის განმავლობაში. იგი შეიქმნა მსოფლიოს ათასობით ადგილას მიწისზედა გაზომვების შერწყმით 66 თანამდებარე გარემოს კოვარიატის ფენით მანქანური სწავლების მოდელში, კედლისა და კედლის რუკის შესაქმნელად. მოდელის მოსამზადებლად გამოყენებული ტყის ნაკვეთის მონაცემები მიღებულია გამოქვეყნებული ლიტერატურიდან, რომელიც შეგიძლიათ იხილოთ ტყის ნახშირბადის მონაცემთა ბაზაში (ForC, რომელიც შენარჩუნებულია სმითსონის ინსტიტუტის (https://github.com/forc-db)) მიერ, ასევე საჯაროდ ხელმისაწვდომი ეროვნული ტყის ინვენტარის გეორეფერენტული მონაცემები. მიუხედავად იმისა, რომ განაკვეთები შეფასდა მთელ ტყესა და სავანის ბიომებზე გლობალურად, ისინი აქ გაფილტრულია "რესტიქციური" ფართობით, როგორც ეს განსაზღვრულია Griscom et al. 2017 (PNAS). რესტიტუციულ ადგილებში გამორიცხავს მშობლიური ბალახებისა და მოსავლის ტერიტორიების ტერიტორიებს, რათა დაიცვას საკვები და ბოჭკოვანი და ბიოლოგიური მრავალფეროვნებისთვის ჰაბიტატი.',
  },
  citation: {
    label: 'ციტატა',
    value:
      'Cook-Patton et al. 2020. Carbon accumulation potential from natural forest regrowth in potentially reforestable areas. Accessed through Global Forest Watch 14/02/2025. www.globalforestwatch.org',
  },
};
